"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrevious = usePrevious;
exports.useDebounce = useDebounce;
exports.didMountEffect = didMountEffect;
exports.useStateHook = useStateHook;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function usePrevious(value) {
  var ref = _react.default.useRef();

  _react.default.useEffect(function () {
    ref.current = value;
  });

  return ref.current;
}

function useDebounce(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var _React$useState = _react.default.useState(value),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      debouncedValue = _React$useState2[0],
      setDebouncedValue = _React$useState2[1];

  _react.default.useEffect(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

function didMountEffect(func, deps) {
  var didMount = _react.default.useRef(false);

  _react.default.useEffect(function () {
    if (didMount.current) func();else didMount.current = true;
  }, deps);
}

function useStateHook(initialState) {
  var ref = _react.default.useRef(false);

  var _React$useState3 = _react.default.useState(initialState),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      state = _React$useState4[0],
      updateState = _React$useState4[1];

  _react.default.useEffect(function () {
    ref.current = true;
    return function () {
      ref.current = false;
    };
  }, []);

  function setState(param) {
    if (ref.current) {
      updateState(function (current) {
        return _objectSpread(_objectSpread({}, current), typeof param === 'function' ? param(current) : param);
      });
    }
  }

  return [state, setState];
}
//# sourceMappingURL=customHooks.js.map